// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pEtVwQNjl7cO8gKa {
	width: fit-content;
	max-width: 1070px;
}
`, "",{"version":3,"sources":["webpack://./packages/rag/src/components/BaseProfileModal/BaseProfileModal.module.css"],"names":[],"mappings":"AAAA;CACC,kBAAkB;CAClB,iBAAiB;AAClB","sourcesContent":[".modal {\n\twidth: fit-content;\n\tmax-width: 1070px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal": `pEtVwQNjl7cO8gKa`
};
export default ___CSS_LOADER_EXPORT___;
